module.exports = __webpack_public_path__ + "static/Majesti-BookItalic-1627421493d9ac459c330fe1a6f642ee.otf";